<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listasituacaoAtendimentos"
        title-table="Situações de Atendimento"
        module="situacaoAtendimentoSettingsModule"
        sort-name="descricao"
        :add-permission="'ROLE_SITUACAO_ATENDIMENTO_INSERIR'"
        :view-permission="'ROLE_SITUACAO_ATENDIMENTO_CONSULTAR'"
        :edit-permission="'ROLE_SITUACAO_ATENDIMENTO_ATUALIZAR'"
        :delete-permission="'ROLE_SITUACAO_ATENDIMENTO_DELETAR'"
        :search-field="'descricao'"
        @add="addNew"
        @edit="edit"
      />
      <FormSituacaoAtendimento
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormSituacaoAtendimento from './forms/FormSituacaoAtendimento.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormSituacaoAtendimento,
  },

  computed: {
    ...mapState('situacaoAtendimentoSettingsModule', {
      listasituacaoAtendimentos: state => state.listasituacaoAtendimentos,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch(
        'situacaoAtendimentoSettingsModule/resetSituacaoAtendimento',
      )
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'situacaoAtendimentoSettingsModule/prepareToEditSituacaoAtendimento',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
